export default "__VITE_ASSET__BmpayT3C__"